import { useState, useEffect } from 'react';
import { useAuth } from '@/App';
import apiClient from '@/utils/apiClient';
import { toast } from 'sonner';

const useParentData = () => {
  const { user } = useAuth();
  const [children, setChildren] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);

  // Fetch children
  useEffect(() => {
    if (user) {
      fetchChildren();
    }
  }, [user]);

  // Fetch dashboard when child changes
  useEffect(() => {
    if (selectedChild) {
      fetchDashboard(selectedChild.id);
    }
  }, [selectedChild]);

  const fetchChildren = async () => {
    try {
      const response = await apiClient.get('/v1/parent/my-children');
      const childrenList = response.data?.children || [];
      setChildren(childrenList);
      
      // Auto-select first child
      if (childrenList.length > 0) {
        setSelectedChild(childrenList[0]);
      }
    } catch (error) {
      console.error('Failed to fetch children:', error);
      toast.error('Failed to load children data');
    } finally {
      setLoading(false);
    }
  };

  const fetchDashboard = async (studentId) => {
    try {
      const response = await apiClient.get(`/v1/parent/dashboard/${studentId}`);
      setDashboardData(response.data);
    } catch (error) {
      console.error('Failed to fetch dashboard:', error);
      toast.error('Failed to load dashboard data');
    }
  };

  const refreshDashboard = () => {
    if (selectedChild) {
      fetchDashboard(selectedChild.id);
    }
  };

  return {
    children,
    selectedChild,
    setSelectedChild,
    loading,
    dashboardData,
    refreshDashboard
  };
};

export default useParentData;
